export function generateOrderCode() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const random = Math.floor(1000 + Math.random() * 9000);

  return `MB-${year}${month}${day}-${random}`;
}

export function getOrderType(serviceItems, materialItems) {
  if (serviceItems.length > 0 && materialItems.length > 0) return "mixed";
  if (serviceItems.length > 0) return "service";
  if (materialItems.length > 0) return "material";
  return "unknown";
}

export function buildAddressPayload(profile, addressForm, selectedAddressType, userId) {
  const useProfile = selectedAddressType === "profile";

  return {
    user_id: userId,
    full_name: profile?.full_name || "Customer",
    phone: profile?.phone || "",
    house_flat_no: useProfile
      ? profile?.house_flat_no || addressForm.houseFlatNo
      : addressForm.houseFlatNo,
    street_area: useProfile
      ? profile?.street_area || addressForm.streetArea
      : addressForm.streetArea,
    city: useProfile ? profile?.city || addressForm.city : addressForm.city,
    state: useProfile ? profile?.state || addressForm.state : addressForm.state,
    country: useProfile
      ? profile?.country || addressForm.country || "India"
      : addressForm.country || "India",
    pincode: useProfile
      ? profile?.pincode || addressForm.pincode
      : addressForm.pincode,
    label: useProfile ? "Profile Address" : "Order Address",
    is_default: false,
  };
}